export default "__VITE_ASSET__c9e4372d__"